// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8f2b93107331b89a","4544":"29046ad685444e73"}[chunkId] + ".css";
};